export const GET_PROJECT_HISTORY_REQUEST = 'GET_PROJECT_HISTORY_REQUEST';
export const GET_PROJECT_HISTORY_SUCCESS = 'GET_PROJECT_HISTORY_SUCCESS';
export const GET_PROJECT_HISTORY_FAIL = 'GET_PROJECT_HISTORY_FAIL';
export const GET_PROJECT_HISTORY_CLEAR = 'GET_PROJECT_HISTORY_CLEAR';

export const GET_TASK_HISTORY_REQUEST = 'GET_TASK_HISTORY_REQUEST';
export const GET_TASK_HISTORY_SUCCESS = 'GET_TASK_HISTORY_SUCCESS';
export const GET_TASK_HISTORY_FAIL = 'GET_TASK_HISTORY_FAIL';
export const GET_TASK_HISTORY_CLEAR = 'GET_TASK_HISTORY_CLEAR';
